export default {
    excess: 'Υπευθυνότητα ζημιών',
    security: 'Εγγύηση ασφαλείας',
    fuel_policy: 'Πολιτική καυσίμων',
    like_for_like: 'Ίδιο με ίδιο',
    full_to_full: 'Γεμάτο προς γεμάτο',
    mileage: 'Χιλιόμετρα: {mileage} μίλια ανά ενοικίαση',
    unlimited_mileage: 'Απεριόριστα χιλιόμετρα',
    non_refundable: 'Μη επιστρέψιμο',
    free_cancellation_until: 'Δωρεάν ακύρωση έως {date}',
    cancellation_with_terms: 'Ακύρωση {0} σύμφωνα με ',
    t_c_text: 'Όροι & Προϋποθέσεις',
    two_free_extras: 'Δύο δωρεάν επιπλέον παροχές κατά την παραλαβή',
    glass_tyres_covered: 'Κάλυψη για τζάμια και ελαστικά',
    spec_fuel_petrol: 'βενζίνη',
    spec_fuel_petrol_diesel: 'βενζίνη/ντίζελ',
};
